import { IApplicationState } from '../../types/redux';

export function selectMortgageBannerLink(state: IApplicationState) {
  return state.suburban.mortgageBannerLink;
}
